// JsFromRoutes CacheKey 8f83870538e89635cd68185c8d325702
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  destroy: /* #__PURE__ */ definePathHelper('delete', '/:account_id/settings/mcp-connections/:id'),
}
